module.exports = __webpack_public_path__ + "assets/img/The-Onset-Website.af87a6e7.jpg";